import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { SettingService } from './shared/services/node-api/setting.service';
import { SeoService } from './shared/services/angular-service/seo.service';
import { LocalStorageService } from './shared/services/angular-service/local-storage.service';
import { Router } from '@angular/router';
import { environment } from  '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  // title = 'Discover Companies Information & Database with TheKredible';
  version = 'Angular version 11.0.7';
  message: any = null;
  toastPosition = "bottom-left";
  deviceType;
  isMaintenance = false; 

  static isBrowser = new BehaviorSubject<boolean>(null);

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    // private router: Router,
    // private seoService: SeoService,
    public settingService: SettingService,
    private renderer: Renderer2,
    private seoService: SeoService,
    private localStorage: LocalStorageService,
      private router: Router,

  ) {
    this.deviceType = localStorage.getItem('deviceType');
    if (this.deviceType == 'mobile') {
      this.toastPosition = "top-center";
    }
    // private msg: AngularFireMessaging,
    AppComponent.isBrowser.next(isPlatformBrowser(platformId));
  }

  ngOnInit(): void {
    this.seoService.getSeo('');
    this.getAllDropdownList();
    // if (this.isMaintenance) {
    //   this.router.navigate(['/maintenance']);
    // }
  }

  getAllDropdownList() {
    this.settingService.getAllDropdowns().then(
      (data: any) => {
        console.log('Config:', 'TRUE');
      },
      (err) => {
        console.log(err);
      },
    );
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
    this.renderer.addClass(document.body, this.localStorage.getItem('device'));
    this.renderer.addClass(document.body, this.localStorage.getItem('deviceType'));
    this.renderer.addClass(document.body, this.localStorage.getItem('browser'));
  }
}
